// import Toast from '@/components/Elements/toast/toast.js'
import _ from 'lodash'
import axios from 'axios';
import resetStore from '../helpers/reset-store'

export const state = () => ({
  pendingTasks: [],
  successTasks: [],
  failedTasks: []
})

export const getters = {
  reports(state) {
    return state.successTasks
  },
  hasPendingReport(state) {
    return state.pendingTasks.length > 0
  }
}

export const mutations = {
  reset: resetStore(state),
  addTask(state, task) {
    state.pendingTasks.push(task)
    state.successTasks = []
  },
  clearTask(state) {
    state.pendingTasks = []
  },
  updateTask(state, data) {
    const task = state.pendingTasks.find(task => task.taskId === data.taskId)

    if (!task) {
      return
    }

    state.pendingTasks = state.pendingTasks.filter(
      o => o.taskId !== task.taskId
    )
    if (data.success) {
      state.successTasks.push({
        ...task,
        ...data,
        createdAt: new Date().valueOf()
      })
    } else {
      state.failedTasks.push(data.taskId)
      // Toast.show({
      //   text: 'Run report failed',
      //   color: 'error',
      //   timeout: 3000,
      //   x: 'right',
      //   dismissable: true,
      //   icon: 'error'
      // })
      // return
    }

    // if (!state.pendingTasks.length) {
      // Toast.show({
      //   text: 'Your report is ready to view',
      //   color: 'ready',
      //   timeout: 2000,
      //   x: 'right',
      //   dismissable: true,
      //   icon: 'ready'
      // })
    // }
  }
}

export const actions = {
  async runReport({ commit, state }, params) {
    // if (state.pendingTasks.length) {
      // Toast.show({
      //   text: 'You have a running report',
      //   color: 'error',
      //   timeout: 3000,
      //   x: 'right',
      //   icon: 'error',
      //   dismissable: true
      // })

    //   return
    // }

    // if (!params.type) {
      // Toast.show({
      //   text: 'Please select the reporting type',
      //   color: 'error',
      //   timeout: 3000,
      //   x: 'right',
      //   icon: 'error',
      //   dismissable: true
      // })

    //   return
    // }
    const taskId = _.uniqueId()
    try {
      commit('addTask', { taskId, type: params.type })
      const { data } = await axios.get('/api/report', {
        params
      })
      data.taskId = taskId
      commit('updateTask', data)
    } catch (e) {
      commit('updateTask', { success: false, taskId })
    }
  }
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};